// Supabase client for the global run board. Public values only: the anon key is designed to ship in the
// bundle; row-level security and the range_* RPCs decide what it may do. The client is null when the env
// is missing, and every board call then reports 'unconfigured' so the game stays local-only.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase: SupabaseClient | null = url && anon
  ? createClient(url, anon, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false } })
  : null;

export const isConfigured = supabase !== null;
